import { PageContainer } from "../components/Common/PageContainer";
import { DashboardLayout } from "../components/DashboardLayout/DashboardLayout";
import { useSession } from "../components/useSession/useSession";

export function Profile() {
  const { session } = useSession();
  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}>
        <h1>Profile</h1>
        <p>Prénom: {session?.user?.firstname}</p>
        <p>Nom: {session?.user?.lastname}</p>
        <p>Email: {session?.user?.email}</p>
      </PageContainer>
    </DashboardLayout>
  );
}
